<p-panelmenu class="sidebar-panel-menu" [multiple]="isMultipleTabOpen" [model]="items"></p-panelmenu>

@if (displayVersion) {
  <div class="version-section-in-sidebar" [title]="displayVersion">
    Version {{displayVersion}}
  </div>
}

<div class="powered-by-section">
  <div class="grid m-0 wrapper">
    <div class="col-12" style="text-align: center;">
      <a [href]="userCommonService.poweredByRedirectBeforeLoginUrl" target="_blank">  
        <img class="company-img" [src]="userCommonService.poweredByBeforeLogoUrl">
      </a>
    </div>
  </div>
</div>

<p-dialog 
  [modal]="true" 
  [(visible)]="isUpdateAvailable" 
  [closable]="false" 
  position="center" 
  styleClass="add-routes-popup estimation"
  [contentStyle]="{'overflow':'auto', 'padding-top': '0px'}" 
  [style]="{width: '500px'}"
>
  <ng-template pTemplate="header">
    <span translate>label_update_available</span>
  </ng-template>

  <div class="grid">
    <div class="col-12">
      <p><strong translate>label_new_update_is_available</strong></p>
      <p><strong>Current Version: </strong> {{ currentVersion }} </p>
      <p><strong>New Version: </strong> {{ newVersion }} </p>
      <div class="whats-new" [innerHTML]="whatsNew"></div>
    </div>
  </div>

  <div class="flex justify-content-end mt-4">
    <button 
      pButton 
      type="button" 
      [label]="'label_update' | translate" 
      class="pr-3 pl-3" 
      (click)="updateNow()">
    </button>

    @if (updateType !== 'MANDATORY') {
      <button 
        pButton 
        type="button" 
        [label]="'label_cancel' | translate" 
        class="ml-3 negative-button" 
        (click)="updateSkipNow()">
      </button>
    }
  </div>
</p-dialog>